import { useState, useEffect } from 'react';
import { Invoice } from '../../../../services/invoice.service';

/**
 * useServiceCharges - Manages service charges API data fetching and loading state
 * @param {Object} invoiceRecord - Invoice record with id property
 * @param {Boolean} shouldFetch - Flag to trigger fetch (e.g., when modal opens)
 * @returns {Object} { isLoading: boolean, apiData: object|null }
 */
export const useServiceCharges = (invoiceRecord, shouldFetch = true) => {
    const [isLoading, setIsLoading] = useState(false);
    const [apiData, setApiData] = useState(null);

    useEffect(() => {
        if (!shouldFetch || !invoiceRecord?.id) return;

        setIsLoading(true);
        Invoice.getInvoiceLookup(invoiceRecord.id, [invoiceRecord.id], [invoiceRecord.id])
            .then(response => {
                console.log('Invoice lookup data fetched:', response.data);
                setApiData(response.data);
                setIsLoading(false);
            })
            .catch(error => {
                console.error('Error fetching invoice lookup:', error);
                setApiData(null);
                setIsLoading(false);
            });
    }, [shouldFetch, invoiceRecord?.id]);

    return { isLoading, apiData };
};
